import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';


export default function ZoneBasicInfoComponent({ handleInnerFormChange, selectedZone }: any) {
    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="MobilityZoneName"
                            name="MobilityZoneName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'MobilityZoneName',

                                )
                            }}
                            type="text"
                            value={selectedZone?.MobilityZoneName}
                        />
                        <InputContainer

                            label="Contact Person"
                            name="ContactPerson"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContactPerson',

                                )
                            }}
                            type="text"
                            value={selectedZone?.ContactPerson}
                        />
                        <InputContainer

                            label="Contact Number"
                            name="ContactNumber"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContactNumber',

                                )
                            }}
                            type="number"
                            value={selectedZone?.ContactNumber}
                        />
                    </div>
                }
                expandedPanel="userInfo"
                headerTitle="Basic Info"
            />

        </>
    )
}